/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var UtensilSpoonIcon = createIcon({
  name: 'UtensilSpoonIcon',
  height: 512,
  width: 512,
  svgPath: 'M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default UtensilSpoonIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/utensil-spoon-icon.js
// module id = 1083
// module chunks = 0